<template>
    <div>
        <div class="row mli" v-on:click="toggleMessageView">
            <div class="select-all"><input type="checkbox" @click.stop="checkedChanged" :checked="isChecked"></div>
            <div class="status"><img src="/icons/icon_mail.png" /></div>
            <div class="subject">{{ message.subject | decodeHtml }}</div>
            <div class="from">{{ message.toMemberDisplayName }}</div>
            <div class="recd-date">{{ message.sentDateUTC | localDateTime }}</div>
            <div style="float:right; width: 56px; margin-left: 5px; height: 42px;">
              <button @click.stop="deleteMessage" v-if="!showViewer">Delete</button>
            </div>
        </div>
        <MessageViewer v-if="showViewer" :message="this.message"></MessageViewer>
    </div>
</template>

<script>

    export default {

        props: ['message', 'isChecked'],

        data() {
            return {
                showViewer: false,
            }
        },

        components: {
            MessageViewer: () => import('../../components/Messages/MessageViewer.vue')
        },

        methods: {
            toggleMessageView: function() {
                this.showViewer = !this.showViewer;
            },
            checkedChanged() {
                const newValue = !this.isChecked;
                this.$emit("checkChanged", {
                    value: newValue,
                    messageID: this.message.messageID
                })
            },
            deleteMessage() {
                this.$emit("deleteMessage", {
                    messageId: this.message.messageID
                });
            },
        }
    }

</script>